import React, { ChangeEvent } from 'react';
import { Typography, Divider, FormControlLabel, Checkbox } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import CloudUpload from '@mui/icons-material/CloudUpload';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import UriApp from './TrustedClientsRedirectUri';
import { Save as SaveIcon } from '@mui/icons-material';
import Cancel from '@mui/icons-material/Cancel';
import { useTrustedClientsToolbarStyles } from '../../../../Common/Styles';
import { TrustedClients } from '../Model';
import { CustomerV2 } from '../../Customer/Model/CustomerModel';
import HeaderToolbar from '../../../../Common/Components/HeaderToolbar';
import SearchBar from '../../../../Common/Components/Controls/SearchBar';
import CustomButton, {
  CustomTextField,
} from '../../../../Common/Components/Controls/InputControls';
import { CardWrapper } from '../../Common/CommonComponents';
import { showToast } from '../../../../lib/toast';

interface TrustedClientsToolbarProps {
  handleDeployClients: () => void;
  onFilterRequest: (event: React.ChangeEvent<HTMLInputElement>) => void;
  OnAdd: (val: TrustedClients) => void;
  customer: CustomerV2;
}

export default function TrustedClientsHeaderToolbar(
  props: Readonly<TrustedClientsToolbarProps>,
) {
  const { onFilterRequest, customer } = props;

  const [TrustedClient] = React.useState({
    ClientID: '',
    ClientUri: '',
    RedirectUris: [''],
    LogoutUri: '',
    AllowedScopes: [''],
    AllowedGrantTypes: [''],
  });
  const [ClientID, setClientID] = React.useState('');
  const [ClientUri, setClientUri] = React.useState('');
  const [LogoutUri, setLogoutUri] = React.useState('');
  const [RedirectUris, setRedirectUris] = React.useState(['']);
  const [AllowedScopes, setAllowedScopes] = React.useState(['']);
  const [AllowedGrantTypes, setAllowedGrantTypes] = React.useState(['']);

  const [ClientIDE, setClientIDE] = React.useState(false);
  const [ClientUriE, setClientUriE] = React.useState(false);
  const [LogoutUriE, setLogoutUriE] = React.useState(false);
  const [RedirectUrisE, setRedirectUrisE] = React.useState(false);

  const { classes } = useTrustedClientsToolbarStyles();
  const createFilterHandler = () => (event: ChangeEvent<HTMLInputElement>) => {
    onFilterRequest(event);
  };

  const scopes = [
    'openid',
    'profile',
    'Email',
    'Address',
    'Phone',
    'OfflineAccess',
  ];

  const grantTypes = [
    { value: 'hybrid', label: 'Hybrid' },
    { value: 'client_credentials', label: 'ClientCredentials' },
    {
      value: 'urn:ietf:params:oauth:grant-type:device_code',
      label: 'DeviceFlow',
    },
    { value: 'implicit', label: 'Implicit' },
    { value: 'authorization_code', label: 'AuthorizationCode' },
    { value: 'password', label: 'ResourceOwnerPassword' },
  ];

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  function handleDeployClients() {
    props.handleDeployClients();
  }

  const handleDialogueClose = () => {
    setOpen(false);
  };

  const validRadio = (str: string[]) => {
    if (str.length >= 2) {
      return true;
    }
    return false;
  };

  const validateClientID = (str: string) => {
    if (str === '') {
      showToast({
        type: 'error',
        title: 'Invalid Client Id',
      });
      return false;
    }
    return true;
  };

  const validateRedirectUris = (str: string[]) => {
    if (str.length === 0 || RedirectUris.filter((i) => i === '').length) {
      return false;
    } else {
      const res = true;
      return res;
    }
  };

  const IsClientValid = (res: boolean) => {
    if (validateClientID(ClientID) && res) {
      setClientIDE(true);
      return true;
    }
    return false;
  };

  const IsRedirectUriValid = (res: boolean) => {
    if (validateRedirectUris(RedirectUris) && res) {
      setRedirectUrisE(true);
      return true;
    }
    showToast({
      type: 'error',
      title: 'Invalid Redirect Uri',
    });
    return false;
  };
  const IsUriValidC = (res: boolean) => {
    if (ClientUri !== null && res) {
      setClientUriE(true);
      return true;
    }
    showToast({
      type: 'error',
      title: 'Invalid Client Uri',
    });
    return false;
  };
  const IsUriValid = (res: boolean) => {
    if (LogoutUri !== null && res) {
      setLogoutUriE(true);
      return true;
    }
    showToast({
      type: 'error',
      title: 'Invalid Client Logout Uri',
    });
    return false;
  };

  const IsRadioValid = (res: boolean) => {
    if (validRadio(AllowedScopes) && res) {
      return true;
    }
    showToast({
      type: 'error',
      title: 'Select proper value for allowed scopes',
    });
    return false;
  };

  const IsRadioValidGT = (res: boolean) => {
    if (validRadio(AllowedGrantTypes) && res) {
      return true;
    }
    showToast({
      type: 'error',
      title: 'Select proper value for allowed grant types',
    });
    return false;
  };

  const Validate = () => {
    let res = true;
    res = IsClientValid(res);
    res = IsRedirectUriValid(res);
    res = IsUriValid(res);
    res = IsUriValidC(res);
    res = IsRadioValid(res);
    res = IsRadioValidGT(res);

    return res;
  };

  function handleSave() {
    if (Validate() === true) {
      TrustedClient.ClientID = ClientID;
      TrustedClient.ClientUri = ClientUri;
      TrustedClient.LogoutUri = LogoutUri;
      TrustedClient.RedirectUris = RedirectUris;
      TrustedClient.AllowedScopes = AllowedScopes;
      TrustedClient.AllowedGrantTypes = AllowedGrantTypes;
      props.OnAdd(TrustedClient);
      setClientID('');
      setClientUri('');
      setLogoutUri('');
      setRedirectUris(['']);
      setAllowedScopes(['']);
      setAllowedGrantTypes(['']);
      setClientIDE(false);
      setClientUriE(false);
      setLogoutUriE(false);
      setRedirectUrisE(false);
      handleDialogueClose();
    }
  }

  function handleDialogueFieldChange(
    event: React.ChangeEvent<HTMLInputElement>,
  ) {
    switch (event.target.name) {
      case 'ClientID':
        setClientID(event.target.value);
        break;

      case 'ClientUri':
        setClientUri(event.target.value);
        break;
      case 'LogoutUri':
        setLogoutUri(event.target.value);
        break;
      case 'RedirectUris': {
        const values = RedirectUris.filter((item: string) => item !== '');
        if (RedirectUris.includes(event.target.value)) {
          setRedirectUris(values);
        } else if (event.target.checked) {
          RedirectUris.push(event.target.value);
        } else {
          const redirectUris = RedirectUris.filter(
            (item: string) => item !== event.target.value,
          );
          setRedirectUris(redirectUris);
        }
        break;
      }

      case 'AllowedScopes': {
        const valuess = [...AllowedScopes];
        if (event.target.checked) {
          valuess.push(event.target.value);
          setAllowedScopes(valuess);
        } else {
          setAllowedScopes(
            valuess.filter((item: string) => item !== event.target.value),
          );
        }
        break;
      }

      case 'AllowedGrantTypes': {
        const val = [...AllowedGrantTypes];
        if (event.target.checked) {
          val.push(event.target.value);
          setAllowedGrantTypes(val);
        } else {
          setAllowedGrantTypes(
            val.filter((item: string) => item !== event.target.value),
          );
        }

        break;
      }
    }
  }

  function handleCheckAS(Name: string) {
    return AllowedScopes.includes(Name);
  }

  function handleCheck(Name: string) {
    return AllowedGrantTypes.includes(Name);
  }

  function onUpdate(val: string[]) {
    const arr = [];
    for (const j in val) {
      arr.push(val[j]);
    }
    setRedirectUris(arr);
  }

  return (
    <HeaderToolbar
      leftContent={
        <Grid2 container spacing={2} alignItems="center">
          <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography variant="h5" padding={1}>
              Trusted Clients for {customer.Subdomain}
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <SearchBar onChange={createFilterHandler()} width="100%" />
          </Grid2>
        </Grid2>
      }
      rightContent={
        <Grid2
          container
          spacing={1}
          alignItems="center"
          justifyContent="flex-start"
          flexWrap="wrap"
        >
          <Grid2 size={{ xs: 12, sm: 'auto' }}>
            <CustomButton
              onClick={handleDeployClients}
              startIcon={<CloudUpload />}
              label="Deploy Clients"
            />
            <CustomButton
              onClick={handleClickOpen}
              startIcon={<AddIcon />}
              label="Add"
            />
          </Grid2>
          <Grid2>
            <Dialog
              open={open}
              fullWidth
              maxWidth="xl"
              onClose={handleDialogueClose}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">Trusted Client</DialogTitle>
              <Divider sx={{ mb: 2 }} />
              <DialogContent>
                <Grid2 container spacing={3}>
                  <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                    <CardWrapper>
                      <Grid2 container spacing={2} alignItems="center">
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <Typography variant="body1">
                            Client ID\Name
                          </Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <CustomTextField
                            error={ClientIDE}
                            required
                            placeholder="Client ID"
                            name="ClientID"
                            value={ClientID}
                            onChange={handleDialogueFieldChange}
                          />
                        </Grid2>
                      </Grid2>
                      <Grid2 container spacing={2} alignItems="center" mt={2}>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <Typography variant="body1">Client Uri</Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <CustomTextField
                            required
                            error={ClientUriE}
                            placeholder="Client Uri"
                            name="ClientUri"
                            value={ClientUri}
                            onChange={handleDialogueFieldChange}
                          />
                        </Grid2>
                      </Grid2>
                      <Grid2 container spacing={2} alignItems="center" mt={2}>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <Typography variant="body1">
                            Redirect Uri's
                          </Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <UriApp
                            onUpdate={(e: string[]) => onUpdate(e)}
                            LUri={RedirectUris}
                            RedirectUrisE={RedirectUrisE}
                          />
                        </Grid2>
                      </Grid2>
                      <Grid2 container spacing={2} alignItems="center" mt={2}>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <Typography variant="body1">Logout Uri</Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <CustomTextField
                            error={LogoutUriE}
                            required
                            placeholder="Logout Uri"
                            name="LogoutUri"
                            value={LogoutUri}
                            onChange={handleDialogueFieldChange}
                          />
                        </Grid2>
                      </Grid2>
                      <Grid2 container spacing={2} alignItems="center" mt={2}>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <Typography variant="body1">Scopes</Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <Grid2 container spacing={2}>
                            {scopes.map((scope) => (
                              <Grid2
                                size={{ xs: 12, sm: 6, md: 4 }}
                                key={scope}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="AllowedScopes"
                                      value={scope}
                                      checked={handleCheckAS(scope)}
                                      onChange={handleDialogueFieldChange}
                                    />
                                  }
                                  label={scope}
                                />
                              </Grid2>
                            ))}
                          </Grid2>
                        </Grid2>
                      </Grid2>
                      <Grid2 container spacing={2} alignItems="center" mt={2}>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <Typography variant="body1">Grant Types</Typography>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <Grid2 container spacing={2}>
                            {grantTypes.map((grant) => (
                              <Grid2
                                size={{ xs: 12, sm: 6, md: 4 }}
                                key={grant.value}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="AllowedGrantTypes"
                                      value={grant.value}
                                      checked={handleCheck(grant.value)}
                                      onChange={handleDialogueFieldChange}
                                    />
                                  }
                                  label={grant.label}
                                />
                              </Grid2>
                            ))}
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    </CardWrapper>
                  </Grid2>
                </Grid2>
              </DialogContent>
              <Divider sx={{ mb: 2 }} />
              <DialogActions>
                <Button
                  variant="contained"
                  onClick={handleSave}
                  className={classes.button}
                  startIcon={<SaveIcon />}
                >
                  Save{' '}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleDialogueClose}
                  className={classes.button}
                  startIcon={<Cancel />}
                >
                  Cancel{' '}
                </Button>
              </DialogActions>
            </Dialog>
          </Grid2>
        </Grid2>
      }
    />
  );
}
